import { useMemo } from 'react';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { useWorkspaceRolesContext } from '~/providers/WorkspaceRolesProvider';

export const useIsApiAdmin = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const { data: roles } = useWorkspaceRolesContext();

  const isApiAdmin = useMemo(() => {
    const adminRoleIds = roles?.filter((role) => role.isAdmin).map((role) => role.id);

    return (
      (currentWorkspace?.plan === 'enterprise' ||
        currentWorkspace?.plan === 'demo' ||
        currentWorkspace?.plan === 'business') &&
      (adminRoleIds?.includes(currentWorkspace.roleId) ?? false)
    );
  }, [currentWorkspace, roles]);

  return { isApiAdmin };
};
